import { defineComponent as _defineComponent } from 'vue'

import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomTextArea',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit;
const { onInput } = setup(emit);

const __returned__ = { emit, onInput }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})